import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/client/Company/FaqPage/FaqPage.tsx");
